import { CButton, CCol, CForm, CFormInput, CFormLabel, CModal, CModalBody, CModalHeader, CModalTitle, CNav, CNavItem, CNavLink, CRow, CTabContent, CTabPane, CModalFooter } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import CloudinaryUploader from './CloudinaryUploader'
import MediaCopy from './MediaCopy'
import { Plus, X } from 'lucide-react'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import PECopyEducation from './PECopyEducation'

const PEMedia = ({ showTab = true, generalExaminationData, setGeneralExaminationData, educationId, educationData }) => {
  const [activeTab, setActiveTab] = useState(0)
  const [file, setFile] = useState([])
  const onClose = () => {
    // fetchEducationsFromLs();
    setFile([])
  }

  useEffect(() => {
    if (educationData) {
      setFile(educationData)
    }
  }, [educationData])

  const handleDeleteFile = (id) => {
    setFile((prevFiles) => {
      return prevFiles.filter((file) => file.id !== id)
    })

    // setFile(prevFiles => {
    //     if (prevFiles.length === 1) return [];
    //     return prevFiles.filter((_, i) => i !== index);
    // });
    // handleFileSave(url)
  }

  const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {
    setFile((prevFiles) => {
      const isDuplicate = prevFiles.some((file) => file.url === url)

      if (isDuplicate) return prevFiles

      return [...prevFiles, { url, type, fileName, id, publicId }]
    })
  }

  const handleDragStart = (e, currentIndex) => {
    e.dataTransfer.setData('text/plain', currentIndex.toString())
    e.dataTransfer.effectAllowed = 'move'
  }

  const handleDrop = (e, targetIndex) => {
    e.preventDefault()
    const currentIndex = parseInt(e.dataTransfer.getData('text/plain'), 10)

    if (currentIndex !== targetIndex) {
      const newFiles = [...file]
      const [movedItem] = newFiles.splice(currentIndex, 1)
      newFiles.splice(targetIndex, 0, movedItem)
      setFile(newFiles)
    }
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'
  }

  const handleFileSave = () => {
    try {
      const AddEditEducation = (data, id) => {
        if (!data || !Array.isArray(data)) {
          return data
        }

        return data.map((item) => {
          if (!item.hasOwnProperty('education')) {
            item.education = []
          }

          if (item.id === id) {
            return { ...item, education: file }
          } else if (item.isHierarchy && Array.isArray(item.hierarchy)) {
            return { ...item, hierarchy: AddEditEducation(item.hierarchy, id) }
          }
          return item
        })
      }

      const updatedData = AddEditEducation(generalExaminationData, educationId)
      setGeneralExaminationData(updatedData)
      toast.success('Media Saved', toastConfig)
      // onClose();
    } catch (error) {
      console.error('Error while updating Media', error)
    }
  }
  return (
    <>
      <div className="w-100 p-2 ">
        <CRow className="d-flex justify-content-center">
          {showTab && (
            <div className="pe-side-panel__header">
              <CNav variant="pills" role="tablist" className="justify-content-center">
                <CNavItem>
                  <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                    Add
                  </CNavLink>
                </CNavItem>
                <CNavItem>
                  <CNavLink
                    active={activeTab === 1}
                    onClick={() => {
                      setActiveTab(1)
                    }}
                  >
                    Copy
                  </CNavLink>
                </CNavItem>
              </CNav>
            </div>
          )}

          <div>
            {
              <div activeTab={activeTab} onActiveTabChange={setActiveTab}>
                <CTabContent className="mt-1   px-3">
                  {activeTab === 0 && (
                    <CTabPane visible={activeTab === 0}>
                      <CCol xs={12} className="mt-3">
                        <CFormLabel>Upload File</CFormLabel>
                        <div className="d-flex  align-item-center gap-2">
                          {/* <div>
                                                {file.length > 0 && (
                                                    <CCol xs={12} className=" ">
                                                        <div className="d-flex  flex-wrap align-items-center gap-2">
                                                            {file.map((fileItem, i) => {
                                                                const isImage = fileItem.type === 'image';
                                                                const isVideo = fileItem.type === 'video';
                                                                const isDocument = fileItem.type === 'document';

                                                                return (
                                                                    <>
                                                                        <div className='d-flex flex-column gap-2 align-items-center'>
                                                                            <div
                                                                                key={i}
                                                                                draggable
                                                                                onDragStart={(e) => handleDragStart(e, i)}
                                                                                onDrop={(e) => handleDrop(e, i)}
                                                                                onDragOver={handleDragOver}
                                                                                className="shadow rounded p-2 position-relative"
                                                                                style={{
                                                                                    width: "100px",
                                                                                    height: "100px",
                                                                                    overflow: "hidden",
                                                                                    borderRadius: "8px",
                                                                                    cursor: "grab",
                                                                                    flexShrink: 0,

                                                                                    background: "#f8f9fa",
                                                                                    position: "relative",
                                                                                }}
                                                                            >

                                                                                <CButton
                                                                                    className="position-absolute top-0 end-0   border-0   rounded-circle"
                                                                                    style={{
                                                                                        width: "20px",
                                                                                        height: "20px",
                                                                                        fontSize: "10px",
                                                                                        background: "var(--ui-color-primary, #2b7cd3)",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        cursor: "pointer",
                                                                                        color: 'white'
                                                                                    }}
                                                                                    onClick={() => handleDeleteFile(fileItem.url, i)}
                                                                                >
                                                                                    x
                                                                                </CButton>

                                                                                {isImage ? (

                                                                                    <>
                                                                                        <img
                                                                                            src={fileItem.url}
                                                                                            alt="Uploaded"
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                height: "100%",
                                                                                                objectFit: "cover",
                                                                                                borderRadius: "8px",
                                                                                            }}
                                                                                        />

                                                                                    </>

                                                                                ) : isVideo ? (
                                                                                    <video
                                                                                        controls
                                                                                        style={{
                                                                                            width: "100%",
                                                                                            height: "100%",
                                                                                            objectFit: "cover",
                                                                                        }}
                                                                                    >
                                                                                        <source src={fileItem.url} type="video/mp4" />
                                                                                    </video>
                                                                                ) : isDocument ? (
                                                                                    <div className="d-flex flex-column align-items-center justify-content-center h-100">
                                                                                        <iframe
                                                                                            src={fileItem.url}
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                height: "100%",
                                                                                                border: "none",
                                                                                                borderRadius: "8px",
                                                                                            }}
                                                                                            title="Document Viewer"
                                                                                        />




                                                                                    </div>
                                                                                ) : (
                                                                                    <a href={fileItem.url} target="_blank" rel="noopener noreferrer" className="text-center">
                                                                                        {fileItem.fileName || "File"}
                                                                                    </a>
                                                                                )}

                                                                            </div>
                                                                            <div style={{ width: '100px', height: '20px', overflow: 'auto', textDecoration: 'none', marginTop: '5px', borderRadius: '10px' }}>
                                                                                <a
                                                                                    href={fileItem.url}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    className="  text-dark"
                                                                                    style={{
                                                                                        display: 'inline-block',
                                                                                        padding: '2px 5px',
                                                                                        backgroundColor: '#f0f0f0',
                                                                                        borderRadius: '4px',
                                                                                        fontSize: '0.75rem',
                                                                                        fontWeight: 'bold',
                                                                                        color: '#333',
                                                                                        textDecoration: 'none',
                                                                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                                                        transition: 'background-color 0.3s ease',
                                                                                    }}
                                                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e0e0e0'}
                                                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                                                                >
                                                                                    {fileItem.fileName || "File"}
                                                                                </a>
                                                                            </div>
                                                                        </div>

                                                                    </>

                                                                );
                                                            })}
                                                        </div>
                                                    </CCol>
                                                )}

                                            </div> */}
                          <CloudinaryUploader onDelete={handleDeleteFile} filesAl={educationData ? educationData : file} onUploadSuccess={handleCloudinaryUpload} />
                        </div>
                        <div className="text-end">
                          {/* <CButton variant='outline' color="secondary" onClick={onClose}>Close</CButton> */}
                          {showTab && (
                            <CButton
                              variant="outline"
                              color="primary"
                              onClick={() => {
                                handleFileSave()
                              }}
                            >
                              Save
                            </CButton>
                          )}
                        </div>
                      </CCol>
                    </CTabPane>
                  )}

                  {activeTab === 1 && (
                    <CTabPane visible={activeTab === 1}>
                      <PECopyEducation parentID={educationId} setGeneralExaminationData={setGeneralExaminationData} setActiveTab={setActiveTab} />
                    </CTabPane>
                  )}
                </CTabContent>
              </div>
            }
          </div>
        </CRow>
      </div>
    </>
    // <CModal scrollable visible={showMediaModel} size='lg'>

    //     <CModalBody>
    //         <CForm>
    //             <CRow className="d-flex justify-content-center">
    //                 {showTab && <div className='bg-white'>
    //                     <CNav variant="pills" role="tablist" className="justify-content-center" >
    //                         <CNavItem>
    //                             <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
    //                                 Add
    //                             </CNavLink>
    //                         </CNavItem>
    //                         <CNavItem>
    //                             <CNavLink active={activeTab === 1} onClick={() => {
    //                                 setActiveTab(1)
    //                             }}>
    //                                 Copy
    //                             </CNavLink>
    //                         </CNavItem>
    //                     </CNav>
    //                 </div>}

    //                 <div>
    //                     {<div activeTab={activeTab} onActiveTabChange={setActiveTab}>

    //                         <CTabContent className="mt-1">
    //                             {activeTab === 0 && <CTabPane visible={activeTab === 0}>
    //                                 <CCol xs={12} className="mt-3">
    //                                     <CFormLabel>Upload File</CFormLabel>
    //                                     <div className='d-flex  align-item-center gap-2'>
    //                                         <div>
    //                                             {file.length > 0 && (
    //                                                 <CCol xs={12} className=" ">
    //                                                     <div className="d-flex  flex-wrap align-items-center gap-2">
    //                                                         {file.map((fileItem, i) => {
    //                                                             const isImage = fileItem.type === 'image';
    //                                                             const isVideo = fileItem.type === 'video';
    //                                                             const isDocument = fileItem.type === 'document';

    //                                                             return (
    //                                                                 <>
    //                                                                     <div className='d-flex flex-column gap-2 align-items-center'>
    //                                                                         <div
    //                                                                             key={i}
    //                                                                             draggable
    //                                                                             onDragStart={(e) => handleDragStart(e, i)}
    //                                                                             onDrop={(e) => handleDrop(e, i)}
    //                                                                             onDragOver={handleDragOver}
    //                                                                             className="shadow rounded p-2 position-relative"
    //                                                                             style={{
    //                                                                                 width: "100px",
    //                                                                                 height: "100px",
    //                                                                                 overflow: "hidden",
    //                                                                                 borderRadius: "8px",
    //                                                                                 cursor: "grab",
    //                                                                                 flexShrink: 0,

    //                                                                                 background: "#f8f9fa",
    //                                                                                 position: "relative",
    //                                                                             }}
    //                                                                         >

    //                                                                             <CButton
    //                                                                                 className="position-absolute top-0 end-0   border-0   rounded-circle"
    //                                                                                 style={{
    //                                                                                     width: "20px",
    //                                                                                     height: "20px",
    //                                                                                     fontSize: "10px",
    //                                                                                     background: "var(--ui-color-primary, #2b7cd3)",
    //                                                                                     display: "flex",
    //                                                                                     alignItems: "center",
    //                                                                                     justifyContent: "center",
    //                                                                                     cursor: "pointer",
    //                                                                                     color: 'white'
    //                                                                                 }}
    //                                                                                 onClick={() => handleDeleteFile(fileItem.url, i)}
    //                                                                             >
    //                                                                                 x
    //                                                                             </CButton>

    //                                                                             {isImage ? (

    //                                                                                 <>
    //                                                                                     <img
    //                                                                                         src={fileItem.url}
    //                                                                                         alt="Uploaded"
    //                                                                                         style={{
    //                                                                                             width: "100%",
    //                                                                                             height: "100%",
    //                                                                                             objectFit: "cover",
    //                                                                                             borderRadius: "8px",
    //                                                                                         }}
    //                                                                                     />

    //                                                                                 </>

    //                                                                             ) : isVideo ? (
    //                                                                                 <video
    //                                                                                     controls
    //                                                                                     style={{
    //                                                                                         width: "100%",
    //                                                                                         height: "100%",
    //                                                                                         objectFit: "cover",
    //                                                                                     }}
    //                                                                                 >
    //                                                                                     <source src={fileItem.url} type="video/mp4" />
    //                                                                                 </video>
    //                                                                             ) : isDocument ? (
    //                                                                                 <div className="d-flex flex-column align-items-center justify-content-center h-100">
    //                                                                                     <iframe
    //                                                                                         src={fileItem.url}
    //                                                                                         style={{
    //                                                                                             width: "100%",
    //                                                                                             height: "100%",
    //                                                                                             border: "none",
    //                                                                                             borderRadius: "8px",
    //                                                                                         }}
    //                                                                                         title="Document Viewer"
    //                                                                                     />

    //                                                                                 </div>
    //                                                                             ) : (
    //                                                                                 <a href={fileItem.url} target="_blank" rel="noopener noreferrer" className="text-center">
    //                                                                                     {fileItem.fileName || "File"}
    //                                                                                 </a>
    //                                                                             )}

    //                                                                         </div>
    //                                                                         <div style={{ width: '100px', height: '20px', overflow: 'auto', textDecoration: 'none', marginTop: '5px', borderRadius: '10px' }}>
    //                                                                             <a
    //                                                                                 href={fileItem.url}
    //                                                                                 target="_blank"
    //                                                                                 rel="noopener noreferrer"
    //                                                                                 className="  text-dark"
    //                                                                                 style={{
    //                                                                                     display: 'inline-block',
    //                                                                                     padding: '2px 5px',
    //                                                                                     backgroundColor: '#f0f0f0',
    //                                                                                     borderRadius: '4px',
    //                                                                                     fontSize: '0.75rem',
    //                                                                                     fontWeight: 'bold',
    //                                                                                     color: '#333',
    //                                                                                     textDecoration: 'none',
    //                                                                                     boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    //                                                                                     transition: 'background-color 0.3s ease',
    //                                                                                 }}
    //                                                                                 onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e0e0e0'}
    //                                                                                 onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
    //                                                                             >
    //                                                                                 {fileItem.fileName || "File"}
    //                                                                             </a>
    //                                                                         </div>
    //                                                                     </div>

    //                                                                 </>

    //                                                             );
    //                                                         })}
    //                                                     </div>
    //                                                 </CCol>
    //                                             )}

    //                                         </div>
    //                                         <CloudinaryUploader onUploadSuccess={handleCloudinaryUpload} />

    //                                     </div>
    //                                 </CCol>
    //                             </CTabPane>}

    //                             {activeTab === 1 && <CTabPane visible={activeTab === 1}>
    //                                 <p>Copy functionality will implement here</p>
    //                             </CTabPane>}
    //                         </CTabContent>

    //                     </div>}
    //                 </div>

    //             </CRow>
    //         </CForm>
    //     </CModalBody>
    //     {activeTab === 0 && <CModalFooter>
    //         <CButton variant='outline' color="secondary" onClick={onClose}>Close</CButton>
    //         {showTab && <CButton variant='outline' color="primary" onClick={() => { handleFileSave(), onClose() }}>{editEducations ? 'Update' : "Save"}</CButton>}
    //     </CModalFooter>}
    // </CModal>
  )
}

export default PEMedia
